export const useStyles = theme => ({
  defaultText: {
    textAlign: 'center',
    width: '100%',
    fontSize: '24px',
    marginTop: '100px',
  },
});
